import React from 'react';
import * as styles from './container.module.sass';
import { IconTextContainer } from '../../organism/IconTextContainer';
import { Card } from '../Card';
import { Color } from '../../enums/color';
import { OpportunitySectionProps } from './props.type';

export const OpportunitySection = (props: OpportunitySectionProps) => {
  return (
    <Card color={Color.SECONDARY} className={styles.opportunity_section}>
      <h2 className={styles.opport_head}>{props.title}</h2>
      <div className={styles.section_content}>
        <div className={styles[props.className]}>
        
        </div>

        <div className={styles.text_icon_wrapper}>
          <IconTextContainer iconWithText={props.iconWithText} className={props.containerClassName} />
        </div>
      </div>
    </Card>
  );
};
